<template>
  <section
    class="fs-panel fs-home-container"
    :class="{ 'fs-home-container-mobile': rootStore.isMobile }"
    v-if="!fileStoreStore.refreshing"
    :style="mobileHeight"
  >
    <header class="header">
      <router-view name="header"></router-view>
    </header>

    <menu-trigger v-if="rootStore.isMobile"></menu-trigger>

    <file-store-menu v-if="!rootStore.isMobile"></file-store-menu>

    <section class="main">
      <router-view></router-view>
    </section>
  </section>
</template>
<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import { EventBus } from '@/eventbus/EventBus'
import FileStoreMenu from '@/features/filestore/FileStoreMenu.vue'
import MenuTrigger from '@/features/filestore/MenuTrigger.vue'

export default {
  components: { MenuTrigger, FileStoreMenu },
  computed: {
    ...mapStores(useFileStoreStore),
    hasArchives() {
      return this.fileStoreStore.hasArchives
    },
    mobileHeight() {
      // `100vh` does not work on mobile - we set it to the actual innerHeight here
      return this.rootStore.isMobile ? this.rootStore.windowInnerHeight : {}
    }
  },
  methods: {
    newArchive() {
      EventBus.emit('createNewArchive')
    }
  }
}
</script>
<style lang="scss" scoped>
@use '../../sass/helpers/_variables.scss' as *;

.fs-home-container {
  position: relative;
  display: grid;
  //height: 100%;
  grid-template-rows: 48px auto;
  grid-template-columns: 170px auto;
  grid-template-areas: 'header header' 'nav main';
}

.header {
  grid-area: header;
  background-color: $bg-grey;
  //  border-bottom: solid 1px $fs-divider;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
}

.main {
  grid-area: main;
  overflow: hidden;
}

//@media (max-width: var(--mobile-width)) {
.fs-home-container-mobile {
  margin-top: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  padding-left: 0;

  grid-template-rows: 66px auto;
  grid-template-columns: 0 auto;
  grid-template-areas: 'header header' 'nav main';
}
//}
</style>
